module.exports = __webpack_public_path__ + "static/img/others_sd.9bdae442.png";